var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1724221152199,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12428,
    "data-spm-anchor-id": "a313x.search_index.0.i5.73f33a81OSZwaf",
    width: 26,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M779.1 142H443.9c-5.4 0-10.2 2.3-13.6 6-0.2 0.1-0.3 0.3-0.5 0.4L189.6 388.6c-0.2 0.1-0.3 0.3-0.4 0.5-3.7 3.4-6 8.2-6 13.6v465.5c0 20.6 16.7 37.2 37.2 37.2h381.3c10.3 0 18.6-8.3 18.6-18.6s-8.3-18.6-18.6-18.6h-344c-20.6 0-37.2-16.7-37.2-37.2V421.3H444c10.3 0 18.6-8.3 18.6-18.6V179.2h279.3c20.6 0 37.2 16.7 37.2 37.2v414.2c0 10.3 8.3 18.6 18.6 18.6s18.6-8.3 18.6-18.6V179.2c0-20.5-16.7-37.2-37.2-37.2zM425.3 384.1H246.8l178.5-178.5v178.5z",
    "p-id": 12429,
    "data-spm-anchor-id": "a313x.search_index.0.i6.73f33a81OSZwaf",
    className: "selected",
    fill: "#8a8a8a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M922.3 694.6c-7.2-7.2-18.9-7.2-26.1 0L755.6 835.2l-83.5-79.7c-6.6-9.2-18.8-10.7-27.1-3.4-8.4 7.3-9.8 20.7-3.1 29.9l94.5 90.3c0.9 1.8 2 3.4 3.5 4.9 3.5 3.5 8.1 5.3 12.7 5.4 4.6 0.4 9.4-1.1 13.3-4.5 1.6-1.4 3-3.1 4.1-4.9L922.3 721c7.2-7.5 7.2-19.2 0-26.4z",
    "p-id": 12430
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.d05805e3ac9082c5173ed20dada30dad.svg";
export { ForwardRef as ReactComponent };